$(function () {

    // init the validator
    // validator files are included in the download package
    // otherwise download from http://1000hz.github.io/bootstrap-validator

    $('#contactForm').validator();


    // when the form is submitted
    /*$('#contactForm').on('submit', function (e) {

        // if the validator does not prevent form submit
        if (!e.isDefaultPrevented()) {
            var url = "http://us.1.p2.webhosting.yahoo.com/forms?login=rjszych";

            // POST values in the background the the script URL
            $.ajax({
                type: "POST",
                url: url,
                dataType: "jsonp",
                data: $(this).serialize(),
                success: function (data)
                {
                    $('#contact-form').find('.messages').html("Thank you for sent us your information");
                        // empty the form
                    $('#contact-form')[0].reset();
                }
            });
            return false;
        }
    })*/
});


// WEBPACK FOOTER //
// src/contact.js